"use client";
import { useEffect, useState } from "react";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import ProjectRadarSVG from "@/src/assets/svg/components/projectRadar/ProjectRadarSVG";

import Button from "components/common/button";
import SubscribeModal from "./ subscribeModal";

import styles from "./styles.module.css";

const ProjectRadarBanner = () => {
  const [isOpen, setIsOpen] = useState(false);

  const newsletterClick = () => {
    Ga4WithEventParameters({
      eventName: "proje-radari-banner",
      eventParameters: { label: "incele" },
    });
  };

  const subscribeOpenClick = () => {
    Ga4WithEventParameters({
      eventName: "proje-radari-banner",
      eventParameters: { label: "abone-ol" },
    });
    window.location.hash = "proje-radari-abone";
    setIsOpen(true);
  };

  const subscribeCloseClick = () => {
    setIsOpen(false);
    window.history.pushState("", document.title, window.location.pathname + window.location.search);
  };

  useEffect(() => {
    if (window.location.hash.length > 0 && window.location.hash === "#proje-radari-abone") {
      setIsOpen(true);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.projectRadarImageAndTitle}>
        <ProjectRadarSVG />
        <p className={styles.text}>
          <span className={styles.boldText}>Ödeme avantajlı fırsat projeleri</span>
          &nbsp;hemen inceleyebilir veya Proje Radarı’na abone olarak her 15 günde bir&nbsp;
          <span className={styles.boldText}>sıfır konut projeleri bültenini</span>
          &nbsp;mail kutunuzda görebilirsiniz!
        </p>

        <div className={styles.buttonsWrapper}>
          <Button buttonClass={styles.buttons} size="M" onClick={newsletterClick} href="/proje-radari">
            Hemen İncele
          </Button>

          <Button buttonClass={styles.buttons} size="M" outline onClick={subscribeOpenClick}>
            Abone Ol
          </Button>
        </div>
      </div>
      <SubscribeModal isOpen={isOpen} close={subscribeCloseClick} />
    </div>
  );
};

export default ProjectRadarBanner;
